import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridModule } from 'ag-grid-angular';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzTableModule } from 'ng-zorro-antd/table';

import { GridPageTemplateComponent } from '../../components/shared/pages-design/grid-page-template/grid-page-template.component';
import { OneColumnAndStepsComponent } from '../../components/shared/pages-design/one-column-and-steps/one-column-and-steps.component';
import { OneColumnComponent } from '../../components/shared/pages-design/one-column/one-column.component';
import { SimplePageTemplateComponent } from '../../components/shared/pages-design/simple-page-template/simple-page-template.component';
import { TwoColumnsFormsComponent } from '../../components/shared/pages-design/two-columns-forms/two-columns-forms.component';
import { TwoColumnsComponent } from '../../components/shared/pages-design/two-columns/two-columns.component';

import {
  CheckInTableComponent,
  ErrorDesactivarSucursalSociedadComponent,
  FormItemErrorComponent,
  FormReactiveCheckBox,
  FormReactiveColorPicker,
  FormReactiveDatePicker,
  FormReactiveInput,
  FormReactiveInputNumber,
  FormReactiveRadioGroup,
  FormReactiveSelect,
  FormReactiveSwitch,
  FormReactiveTextArea,
  FullPageTemplateComponent,
  GeneralFormComponent,
  GeneralTableComponent,
} from '@global-components/shared';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { ColorPickerModule } from 'ngx-color-picker';
import { BaseGridComponent } from '@app/components/shared/data/grid/grid.component';
import { LanguageSelectorComponent } from '@app/components/shared/language-selector/language-selector.component';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { GeneralTableV2Component } from '@app/components/shared/general-template/general-table-v2/general-table.component';
import { TableRowEditHintDirective } from '@app/components/shared/table-row-edit-hint/table-row-edit-hint.directive';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { BaseNewGridComponent } from "@app/components/shared/data/new-grid/new-grid.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AgGridModule,
    NgSelectModule,
    NzDividerModule,
    NzFormModule,
    NzTableModule,
    NzInputModule,
    NzSelectModule,
    NzRadioModule,
    NzDatePickerModule,
    NzTooltipModule,
    NzBreadCrumbModule,
    NzSpinModule,
    NzAlertModule,
    NzButtonModule,
    NzInputNumberModule,
    NzPaginationModule,
    NzCheckboxModule,
    NzSwitchModule,
    ColorPickerModule,
  ],
  declarations: [
    BaseGridComponent,
    BaseNewGridComponent,
    OneColumnComponent,
    OneColumnAndStepsComponent,
    TwoColumnsComponent,
    TwoColumnsFormsComponent,
    LanguageSelectorComponent,
    SimplePageTemplateComponent,
    FullPageTemplateComponent,
    GridPageTemplateComponent,
    FormItemErrorComponent,
    FormReactiveInput,
    FormReactiveInputNumber,
    FormReactiveSelect,
    FormReactiveDatePicker,
    FormReactiveRadioGroup,
    FormReactiveColorPicker,
    FormReactiveCheckBox,
    FormReactiveSwitch,
    FormReactiveTextArea,
    ErrorDesactivarSucursalSociedadComponent,
    CheckInTableComponent,
    GeneralTableComponent,
    GeneralTableV2Component,
    TableRowEditHintDirective,
    GeneralFormComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AgGridModule,
    NgSelectModule,
    NzDividerModule,
    NzFormModule,
    NzTableModule,
    NzInputModule,
    NzSelectModule,
    NzRadioModule,
    NzDatePickerModule,
    NzTooltipModule,
    NzBreadCrumbModule,
    NzSpinModule,
    NzAlertModule,
    NzButtonModule,
    NzInputNumberModule,
    NzPaginationModule,
    NzCheckboxModule,
    NzSwitchModule,
    ColorPickerModule,
    BaseGridComponent,
    BaseNewGridComponent,
    OneColumnComponent,
    TwoColumnsComponent,
    TwoColumnsFormsComponent,
    LanguageSelectorComponent,
    OneColumnAndStepsComponent,
    SimplePageTemplateComponent,
    FullPageTemplateComponent,
    GridPageTemplateComponent,
    FormItemErrorComponent,
    FormReactiveInput,
    FormReactiveInputNumber,
    FormReactiveSelect,
    FormReactiveDatePicker,
    FormReactiveRadioGroup,
    FormReactiveColorPicker,
    FormReactiveCheckBox,
    FormReactiveSwitch,
    ErrorDesactivarSucursalSociedadComponent,
    CheckInTableComponent,
    GeneralTableComponent,
    GeneralTableV2Component,
    TableRowEditHintDirective,
    GeneralFormComponent,
    FormReactiveTextArea
  ],
})
export class SharedModule {}
